/**
 * Reusable User Limit Badge Component
 * Displays current/max users with color coding
 */

interface UserLimitBadgeProps {
  currentUsers: number;
  maxUsers: number;
  variant?: 'default' | 'large' | 'compact';
}

export function UserLimitBadge({ currentUsers, maxUsers, variant = 'default' }: UserLimitBadgeProps) {
  const isAtLimit = currentUsers >= maxUsers;
  const isNearLimit = currentUsers >= maxUsers * 0.8;

  const backgroundColor = isAtLimit ? '#fef3c7' : isNearLimit ? '#dbeafe' : '#f3f4f6';
  const borderColor = isAtLimit ? '#fbbf24' : isNearLimit ? '#3b82f6' : '#d1d5db';
  const textColor = isAtLimit ? '#92400e' : isNearLimit ? '#1e40af' : '#374151';

  const styles = {
    default: {
      fontSize: '14px',
      padding: '8px 12px',
    },
    large: {
      fontSize: '32px',
      padding: '0',
    },
    compact: {
      fontSize: '12px',
      padding: '4px 8px',
    },
  };

  const style = styles[variant];

  return (
    <span
      style={{
        ...style,
        backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius: '6px',
        fontWeight: '700',
        color: textColor,
        display: 'inline-block',
      }}
      title={`${currentUsers} of ${maxUsers} user slots used`}
    >
      {currentUsers}/{maxUsers}
    </span>
  );
}
